import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconLessThan(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7399 4.32733C15.1114 4.73599 15.0813 5.36844 14.6727 5.73995L9.98661 10L14.6727 14.2601C15.0813 14.6316 15.1114 15.264 14.7399 15.6727C14.3684 16.0813 13.736 16.1115 13.3273 15.7399L7.82733 10.7399C7.61885 10.5504 7.5 10.2818 7.5 10C7.5 9.71826 7.61885 9.44959 7.82733 9.26007L13.3273 4.26007C13.736 3.88856 14.3684 3.91868 14.7399 4.32733Z"
        fill="currentColor"
      />
      <path
        d="M5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
